import { languageToUrl } from 'pricing-pages-ui-components/utils/languageUtils';
import { AllRoutes, MARKETING } from '../constants/routes';
import { getIsAcceptanceTest } from '../utils/envUtils';
import { getHostname, getPathname, getSearch, navigateTo } from './browserNav';

/*
 * Returns the canonical public pricing URL for `slug` in the user's locale.
 * Mirrors pricing-pages-lib/utils/urls.getAbsolutePricingPageUrl (isAppAuth: false
 * branch) so public-app has no dependency on pricing-pages-lib for this redirect.
 */
function getPublicPricingPageUrl(slug, isQA) {
  const domain = isQA ? 'wthubspot' : 'hubspot';
  return languageToUrl({
    en: `https://www.${domain}.com/pricing/${slug}`,
    de: `https://www.${domain}.de/pricing/${slug}`,
    es: `https://www.${domain}.es/pricing/${slug}`,
    pt: `https://br.${domain}.com/pricing/${slug}`,
    fr: `https://www.${domain}.fr/pricing/${slug}`,
    ja: `https://www.${domain}.jp/pricing/${slug}`
  });
}

/**
 * Returns `true` when a redirect has been scheduled so the caller can skip
 * booting the rest of the app (avoids wasted renders/fetches before unload).
 *
 * @param originalSearch – pass the search string captured *before* the router
 *   starts, because React Router redirects (e.g. "/" → "/marketing") may strip
 *   query params like `forceRedirect` that this function needs.
 */
export function redirectNonProxied(originalSearch) {
  const hostname = getHostname();
  const search = originalSearch !== null && originalSearch !== void 0 ? originalSearch : getSearch();
  const isOnApp = !!hostname.match(/^app(-.*)?\.hubspot(qa)?\.com/);
  const forceRedirect = new URLSearchParams(search).has('forceRedirect');
  if (!isOnApp || getIsAcceptanceTest() && !forceRedirect) {
    return false;
  }
  const isQA = hostname.indexOf('qa') >= 0;
  const productLine = getPathname().split('/').find(slug => slug && AllRoutes.includes(slug)) || MARKETING;
  const newUrl = `${getPublicPricingPageUrl(productLine, isQA)}${search}`;
  navigateTo(newUrl);
  return true;
}